import { useQuery } from '@tanstack/react-query';
import { BreadcrumbGroup, Link, Spinner } from '@cloudscape-design/components'; // Importing the Spinner component

import { useNavigate } from 'react-router-dom';

export default function View() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#101c2c] text-white font-sans p-4">
      <div className="mb-4">
        <BreadcrumbGroup
          items={[{ text: 'Manage', href: '/manage' }]}
          onFollow={(e) => {
            e.preventDefault();
            navigate(e.detail.href);
          }}
        />
      </div>
      <div>
        <h1 className="text-3xl font-bold mb-6">Manage</h1>
        <div className="flex justify-start">
          <button
            className="bg-white text-black py-2 px-4 rounded hover:bg-gray-200 transition-colors duration-300"
            onClick={(e) => {
              e.preventDefault();
              navigate('/manage/events');
            }}
          >
            Events
          </button>
        </div>
      </div>
    </div>
  );
}
